import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Add = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.85 7a.85.85 0 0 0-1.7 0v4.15H7a.85.85 0 0 0 0 1.7h4.15V17a.85.85 0 0 0 1.7 0v-4.15H17a.85.85 0 0 0 0-1.7h-4.15V7Z"
      fill={color}
    />
  </Svg>
)

export default Add
